var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-layout"},[_c('div',{ref:"page",class:['page-content', _vm.layout, _vm.pageWidth]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }